import apiClient from "../client";

// GET /api/reports/monthly/ui
export const getMonthlyReport = async (params = {}) => {
  const query = new URLSearchParams();
  query.set("year", params.year);
  query.set("month", params.month);

  (params.macIds || []).forEach((id) => query.append("macIds", id));
  (params.associateIds || []).forEach((id) => query.append("associateIds", id));
  (params.statuses || []).forEach((s) => query.append("statuses", s));
  (params.fteValues || []).forEach((v) => query.append("fteValues", v));

  const response = await apiClient.get(`/reports/monthly/ui?${query.toString()}`);
  return response.data;
};

// GET /api/reports/monthly (Excel export — opens in new tab)
export const exportMonthlyReport = (year, month) => {
  window.open(
    `${apiClient.defaults.baseURL}/reports/monthly?year=${year}&month=${month}`,
    "_blank"
  );
};

// GET /api/macs
export const getMacs = async () => {
  const response = await apiClient.get("/macs");
  return response.data;
};

// GET /api/associates
export const getAssociates = async () => {
  const response = await apiClient.get("/associates");
  return response.data;
};